import { invokeRPC } from './socket.js'

export function checkVersion(versionNumber) {
  return invokeRPC('versioning', 'checkVersion', { version_number: versionNumber })
}

export function changeVersion(desiredVersion) {
  return invokeRPC('versioning', 'changeVersion', { new_version: desiredVersion })
}

export function getVersion(versionNumber) {
  return invokeRPC('versioning', 'getVersion', { version_number: versionNumber })
}